var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6761 14.821L15.3029 17.5L16.3743 16.4073L2.73788 2.5L1.6665 3.59266L4.23731 6.21454C3.09999 7.3174 2.42408 8.5388 2.42408 9.38739C2.42408 11.319 6.17462 15.1821 10.4005 15.1821C11.1836 15.1821 11.9489 15.0494 12.6761 14.821ZM10.7387 12.8451L6.98835 9.02023C6.97593 9.14088 6.96957 9.26338 6.96957 9.38739C6.96957 11.3076 8.49588 12.8642 10.3787 12.8642C10.5003 12.8642 10.6204 12.8577 10.7387 12.8451Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5185 13.3492C17.2201 12.0843 18.3332 10.4458 18.3332 9.38739C18.3332 7.45581 15.1235 3.59266 10.4005 3.59266C9.09033 3.59266 7.86356 3.92388 6.78367 4.44083L8.67838 6.37318C9.17885 6.07891 9.75949 5.91055 10.3787 5.91055C12.2615 5.91055 13.7878 7.46718 13.7878 9.38739C13.7878 10.0189 13.6227 10.611 13.3342 11.1215L15.5185 13.3492Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2726 9.38739C12.2726 9.58466 12.2436 9.77503 12.1897 9.9543L9.82281 7.54034C9.99858 7.48539 10.1852 7.45581 10.3787 7.45581C11.4247 7.45581 12.2726 8.32061 12.2726 9.38739Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.89539e4580b1687f47602e0ca61eff28.svg";
export { ForwardRef as ReactComponent };